import styled from 'styled-components';

interface ContainerProps {
  showFullHostImage?: boolean;
}

export const Container = styled.div<ContainerProps>`
  padding: ${p => (p.showFullHostImage ? 0 : '30px')};
  font-family: 'Rubik';
`;
export const Title = styled.p`
  font-size: 24px;
  line-height: 28px;
  font-weight: 700;
  color: #222;
`;
export const SubTitle = styled.p`
  font-size: 14px;
  color: #222;
  margin-top: 8px;
`;
export const FullImg = styled.img`
  width: 100%;
  height: 600px;
  object-fit: cover;
  border-radius: 10px;
  vertical-align: top;
`;
export const ModalHdr = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin-bottom: 20px;
  ::before {
    width: 267px;
    height: 1px;
    background: linear-gradient(90deg, #d8d8d8, rgba(255, 255, 255, 0));
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
  }
`;
export const HostImg = styled.div`
  margin-left: 30px;
`;

export const HostList = styled.ul`
  display: flex;
  margin-bottom: 20px;
  li {
    display: flex;
    align-items: center;
    margin-right: 10px;
    font-size: 14px;
    line-height: 18px;
    color: #222;
  }
`;
export const HostBio = styled.p`
  font-size: 14px;
  line-height: 18px;
  color: #222;
  margin-bottom: 16px;
`;
export const Responsibilities = styled.p`
  font-size: 14px;
  line-height: 18px;
  color: #222;
  margin-bottom: 16px;
  span {
    font-weight: 600;
  }
   > div {
    display:flex
    align-items: center
  }
`;
